import { useEffect, useRef } from 'react'
import { httpClient } from '@sphere/gateway/shared'

import { firebaseVapidKey } from '../config/env.config'
import { requestFcmWebToken } from '../config/firebase.client'


/**
 * Après bootstrap, enregistre le token FCM Web auprès du gateway → notification service.
 * 
 * Pour stopper l'enregistrement web push même s'il y a une erreur, appelez simplement `useWebPushDeviceRegistration(false)`
 * ou passez `enabled` à false.
 * Cela arrêtera le hook dès la prochaine exécution de l'effet et ne refera plus de tentative,
 * car doneRef et stopRef continueront de bloquer les appels suivants.
 */
export function useWebPushDeviceRegistration(enabled: boolean) {
  const doneRef = useRef(false)
  const stopRef = useRef(false)

  useEffect(() => {
    if (!enabled || doneRef.current || stopRef.current) return

    const vapid = firebaseVapidKey
    if (!vapid) {
      console.warn(
        '[FCM] VITE_FIREBASE_VAPID_KEY manquant — enregistrement device ignoré',
      )
      stopRef.current = true // On stoppe même si la clé est absente
      return
    }

    let cancelled = false

    void (async () => {
      try {
        console.log('requesting token')
        const token = await requestFcmWebToken(vapid)
        if (!token) {
          stopRef.current = true // On stoppe même si aucun token reçu
          return
        }

        if (cancelled) return

        console.log('token', token)

        await httpClient.post('/notifications/v1/device-tokens', {
          token,
          platform: 'web',
        })
        doneRef.current = true
        stopRef.current = true // On stoppe même après succès
      } catch (e) {
        console.warn('[FCM] Échec enregistrement du token auprès du backend', e)
        doneRef.current = true
        stopRef.current = true // On stoppe même s'il y a une erreur
      }
    })()

    return () => {
      cancelled = true
    }
  }, [enabled])
}
